import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';

import { openIntercom } from '../globals-service';

import featuredImage from '../images/featured/main.png';
import secondaryImage from '../images/featured/secondary.png';

class AppFeatured extends PureComponent {
    state = {
        loaded: false
    }

    handleLearnMoreClick = () => {
        openIntercom();
    }

    handleImageLoaded = () => {
        this.setState({
            loaded: true
        });
    }

    render() {
        const { t } = this.props;

        return (
            <div className="app-featured">
                <div className="article">
                    <h2><span className="label">{ t('featured.label') }</span> { t('featured.title') }</h2>

                    <p>{ t('featured.description') }</p>
                </div>

                <div className={'image ' + (!this.state.loaded ? ' invisible' : '')}>
                    <img className="main" src={featuredImage} alt="Feature" onLoad={this.handleImageLoaded} />
                    <img className="secondary" style={{display: 'none'}} src={secondaryImage} width="128" height="128" alt="Feature secondary" />
                </div>
            </div>
        );
    }
}

export default withTranslation('onboarding')(AppFeatured);
